import * as React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";

const TransactionTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    return (
        <Tab tabId="transaction-tabs">
            <TabItem title="Transaction Activity" link="/transactions" tabNo="1" selectedTab={props.selectedTab} />
            <TabItem title="Financial Accounts" link="/transactions/financial-account" tabNo="2" selectedTab={props.selectedTab} />
        </Tab>
    );
};

export default TransactionTab;
